exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".subTotalSummary-priceSummary{padding:0.5rem 0rem}.subTotalSummary-totalPriceText{font-family:'Lato-Bold', sans-serif;font-weight:bold;color:var(--text)}.subTotalSummary-priceItem{display:flex;justify-content:space-between;padding:0.5rem 0rem;color:var(--text)}\n", ""]);

// exports
